import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import userTable from './user-table.vue';
import addAcount from './add-model.vue';
import { getRoleList } from '../../../api/user';
import { EventBus } from '@blade/common';
let default_1 = class extends Vue {
    title = `${this.$t('editDevice')}`;
    addDialogVisible = false;
    type = 'add';
    form = {
        keyword: '',
        role_id: '',
        state: ''
    };
    roleNameOptions = [];
    options = ['ENABLE', 'DISABLE'];
    state = '';
    showAddModel() {
        this.addDialogVisible = true;
        this.type = 'add';
        EventBus.$emit('getuserDetail', false);
    }
    getRoleList() {
        getRoleList().then((res) => {
            this.roleNameOptions = res;
        });
    }
    // 更改状态
    changState(value) {
        this.state = value;
    }
    async mounted() {
        this.getRoleList();
    }
};
default_1 = __decorate([
    Component({
        name: 'accountRightTable',
        components: {
            userTable,
            addAcount,
        },
        i18n: {
            messages: {
                en: {
                    pleaseSelectRole: 'Role Select',
                    pleaseSelectStatus: 'Status Select',
                    addUser: 'Add User',
                    department: 'User',
                    typing: 'Typing'
                },
                zh: {
                    pleaseSelectRole: '角色选择',
                    pleaseSelectStatus: '状态选择',
                    addUser: '添加用户',
                    department: '用户',
                    typing: '关键字'
                },
            },
        },
    })
], default_1);
export default default_1;
